var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("custom-page", {
    attrs: {
      "can-be-create": false,
      admin: true,
      history: true
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };